import React, { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { showSuccessMessage } from '../../helpers/showMessage';
import CVAccordion from './CVAccordion';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { Container, Content } from './EditCV.styled';
import { Body3 } from './../../app/common/typography/index';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';

const EditCV = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loc: any = { ...location };
  const { hotelData } = loc.state;

  const [updatedHotelData, setUpdatedHotelData] = useState<any>([]);
  const [departmentList] = useState<any>([
    { id: 1, value: 'Front Of House' },
    { id: 2, value: 'Housekeeping' },
    { id: 3, value: 'Food And Beverage' },
    { id: 4, value: 'Product' },
    { id: 5, value: 'Other' },
    { id: 6, value: 'Display Only' },
  ]);

  useEffect(() => {
    if (hotelData.currentHotel) {
      for (const key in hotelData.currentHotel) {
        if (hotelData.currentHotel.hasOwnProperty(key)) {
          for (const index in hotelData.currentHotel[key]) {
            if (hotelData.currentHotel[key].hasOwnProperty(index)) {
              hotelData.currentHotel[key][index].isActivePosition =
                !hotelData.currentHotel[key][index].endDate;
              hotelData.currentHotel[key][index].isCurrentHotel = true;
            }
          }

          hotelData.currentHotel[key].push({
            ...initialValues,
            hotelName: hotelData.currentHotel[key][0].hotelName,
            hotelId: hotelData.currentHotel[key][0].hotel
              ? hotelData.currentHotel[key][0].hotel.id
              : null,
            city: hotelData.currentHotel[key][0].city,
            state: hotelData.currentHotel[key][0].state,
            country: hotelData.currentHotel[key][0].country,
            isAddingNewPosition: true,
            isCurrentHotel: true,
          });
        }
      }
    }
    if (hotelData.previousHotel) {
      for (const key in hotelData.previousHotel) {
        if (hotelData.previousHotel.hasOwnProperty(key)) {
          for (const index in hotelData.previousHotel[key]) {
            if (hotelData.previousHotel[key].hasOwnProperty(index)) {
              hotelData.previousHotel[key][index].isActivePosition =
                !hotelData.previousHotel[key][index].endDate;
              hotelData.previousHotel[key][index].isCurrentHotel = false;
            }
          }
          hotelData.previousHotel[key].push({
            ...initialValues,
            hotelName: hotelData.previousHotel[key][0].hotelName,
            hotelId: hotelData.previousHotel[key][0].hotel
              ? hotelData.previousHotel[key][0].hotel.id
              : null,
            city: hotelData.previousHotel[key][0].city,
            state: hotelData.previousHotel[key][0].state,
            country: hotelData.previousHotel[key][0].country,
            isAddingNewPosition: true,
            isCurrentHotel: false,
          });
        }
      }
    }
    setUpdatedHotelData(hotelData);
    setValues(hotelData);
  }, [hotelData]);

  const initialValues = {
    hotelName: '',
    department: '',
    currentJobTitle: '',
    level: '',
    startDate: '',
    endDate: '',
    jobDescription: '',
  };

  const [values, setValues] = useState<any>([initialValues]);
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentOpenedAccordionItemIndex, setCurrentOpenedAccordionItemIndex] =
    useState(-1);

  const handleChange = (event, isCurrentHotel, hotelName, index) => {
    const { name, value } = event.target;
    const newCvInputValues = { ...updatedHotelData };
    newCvInputValues[isCurrentHotel ? 'currentHotel' : 'previousHotel'][
      hotelName
    ][index][name] = value;
    setValues(newCvInputValues);
    if (value) {
      const newErrors = [...errors];
      if (
        newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'] &&
        newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][
          hotelName
        ] &&
        newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][hotelName][
          index
        ]
      ) {
        delete newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][
          hotelName
        ][index][name];
      }
      setErrors(newErrors);
    } else {
      const newErrors: any = [...errors];

      const hotelIdentifier = isCurrentHotel ? 'currentHotel' : 'previousHotel';
      newErrors[hotelIdentifier] = newErrors[hotelIdentifier] || {};
      newErrors[hotelIdentifier][hotelName] =
        newErrors[hotelIdentifier][hotelName] || [];
      newErrors[hotelIdentifier][hotelName][index] =
        newErrors[hotelIdentifier][hotelName][index] || {};
      newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][hotelName][
        index
      ][name] = `${name} is required`;
      setErrors(newErrors);
    }
  };

  const validateInputs = () => {
    setErrors([]);
    // validate input fields
    const newErrors: any = [];
    Object.entries(updatedHotelData).forEach(([key, hotels]: any) => {
      Object.entries(hotels).forEach(([hotelName, values]: any, index) => {
        values.forEach((value, index) => {
          if (
            !value.department &&
            !value.currentJobTitle &&
            !value.level &&
            !value.jobDescription &&
            !value.startDate &&
            !value.isActivePosition &&
            !value.endDate
          ) {
            return;
          }

          const requiredFields = [
            'department',
            'currentJobTitle',
            'level',
            'jobDescription',
            'startDate',
            'endDate',
          ];

          if (value.isActivePosition) {
            requiredFields.splice(requiredFields.indexOf('endDate'), 1);
          }

          if (
            requiredFields.some(
              (field) =>
                !value[field] ||
                (value[field] &&
                  typeof value[field] === 'string' &&
                  !value[field].trim())
            )
          ) {
            const hotelIdentifier = value.isCurrentHotel
              ? 'currentHotel'
              : 'previousHotel';
            newErrors[hotelIdentifier] = newErrors[hotelIdentifier] || {};
            newErrors[hotelIdentifier][hotelName] =
              newErrors[hotelIdentifier][hotelName] || [];
            newErrors[hotelIdentifier][hotelName][index] =
              newErrors[hotelIdentifier][hotelName][index] || {};

            requiredFields.forEach((field) => {
              if (
                !value[field] ||
                (value[field] &&
                  typeof value[field] === 'string' &&
                  !value[field].trim())
              ) {
                newErrors[hotelIdentifier][hotelName][index][field] =
                  `${field} is required`;
              }
            });
          }
        });
      });
    });

    if (Object.entries(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    return true;
  };

  const handleCVSave = async () => {
    const validateInputsResult = validateInputs();
    if (!validateInputsResult) {
      return false;
    }

    setIsLoading(true);
    const formattedData: any = [];

    for (const hotelType in values) {
      if (values.hasOwnProperty(hotelType)) {
        for (const hotelName in values[hotelType]) {
          if (values[hotelType].hasOwnProperty(hotelName)) {
            formattedData.push(
              ...values[hotelType][hotelName].filter(
                (value) => value.department
              )
            );
          }
        }
      }
    }
    for (const key in formattedData) {
      if (typeof formattedData[key] === 'string' && formattedData[key]) {
        formattedData[key] = formattedData[key].replace(/\s+/g, ' ').trim();
      }
    }

    showSuccessMessage('CV Updated Successfully');
    setIsLoading(false);
    setErrors([]);
    navigate('/profile/cv');
    return true;
  };

  const renderHotelSection = (hotelData, isCurrent) => {
    if (hotelData && Object.entries(hotelData).length > 0) {
      return (
        <>
          <Body3>{isCurrent ? 'Current Hotel' : 'Previous Hotel'}</Body3>
          <Content>
            {Object.entries(hotelData).map(([key, value], index) => (
              <CVAccordion
                key={index}
                values={value}
                index={index}
                errors={errors}
                handleChange={handleChange}
                setErrors={setErrors}
                setValues={setValues}
                currentOpenedAccordionItemIndex={
                  currentOpenedAccordionItemIndex
                }
                setCurrentOpenedAccordionItemIndex={
                  setCurrentOpenedAccordionItemIndex
                }
                departmentList={departmentList}
                isCurrentHotel={isCurrent}
                allHotelData={updatedHotelData}
              />
            ))}
          </Content>
        </>
      );
    }
    return null;
  };

  return (
    <>
      <HeaderContainer>
        <AppHeader title="Edit CV" navigateTo="/profile/cv" />
      </HeaderContainer>
      <Container>
        {renderHotelSection(updatedHotelData.currentHotel, true)}
        {renderHotelSection(updatedHotelData.previousHotel, false)}
        <ButtonLarge
          title="Save"
          onClick={() => handleCVSave()}
          disabled={isLoading}
        />
      </Container>
    </>
  );
};

export default EditCV;
